/* eslint-disable */
// url可能不规范 有可能是#先也可能是?先
function getPage(url) {
    return url.replace(/[?#].*$/, ''); // 除去search与hash的部分
}

function getPageName(url) {
    //  有可能是空 空即文件夹下的默认首页
    url = getPage(url);
    // 以/结束 pageName为空 默认首页 否则说明指定了特定文件 将特定文件去掉 换成目标文件
    // tbd 应把域名及端口部分除去的基础上replace
    if (/\/$/.test(url)) {
        return '';
    } else {
        return url.replace(/.*\//, '');
    }
}

function getPath(url) {
    // 不包含pageName
    url = getPage(url);
    // 以/结束 pageName为空 默认首页 否则说明指定了特定文件 将特定文件去掉 换成目标文件
    // tbd 应把域名及端口部分除去的基础上replace
    if (/\/$/.test(url)) {
        return url;
    } else {
        return url.replace(/[^/]*?$/, '');
    }
}

function getSearch(url) {
    if (url.indexOf('?') >= 0) {
        return url.replace(/^.*?\?/, '').replace(/#.*$/, ''); // 去掉?前的所有字符 去掉#及后的所有字符
    }
    return '';
}

function getHash(url) {
    if (url.indexOf('#') >= 0) {
        return url.replace(/^.*?#/, '').replace(/\?.*$/, ''); // 去掉#前的所有字符 去掉?及后的所有字符
    }
    return '';
}

function changePage(url, page) {
    // tbd 保留客户端卡开页面时携带的位置参数与系统参数等
    var path = getPath(url);
    var search = getSearch(url);
    var hash = getHash(url);

    // 不以/结束 表示仅有域名没有path亦没有pageName
    /* if (!/\/$/.test(url)) {
        path = path + '/';
    } */

    return path + page;
}

function changePageKeepState(url, page) {
    // tbd 保留客户端卡开页面时携带的位置参数与系统参数等
    var search = getSearch(url);
    var hash = getHash(url);
    return changePage(url, page) + (search ? '?' + search : '') + (hash ? '#' + hash : '');
}

function writeParam(url, param) {
    var page = getPage(url);
    var search = getSearch(url);
    var hash = getHash(url);

    var searchArr = search ? search.split('&') : [];
    var newParamKeyArr = [];

    // 更新原有的参数 并找出哪些参数是新添件的
    for (var key in param) {
        var found = false;
        for (var idx = 0, len = searchArr.length; idx < len; idx++) {
            var item = searchArr[idx];
            var pair = item.split('=');
            var name = pair[0];
            if (name == key) {
                // 参数已存在 更新之
                if (param[key] !== undefined && param[key] !== null) {
                    searchArr[idx] = key + '=' + window.encodeURIComponent(param[key]);
                } else {
                    searchArr[idx] = key;
                }
                found = true;
                break;
            }
        }
        if (!found) {
            // 没找到 不存在 添加到newParamKeyArr
            newParamKeyArr.push(key);
        }
    }

    // 将新添加的参数append到原参数列表里
    for (var idx = 0, len = newParamKeyArr.length; idx < len; idx++) {
        var key = newParamKeyArr[idx];
        if (param[key] !== undefined && param[key] !== null) {
            searchArr.push(key + '=' + window.encodeURIComponent(param[key]));
        } else {
            searchArr.push(key);
        }
    }

    search = searchArr.length ? '?' + searchArr.join('&') : '';
    hash = hash ? '#' + hash : '';
    url = page + search + hash;
    return url;
}

function setHash(url, hash) {
    var page = getPage(url);
    var search = getSearch(url);
    if (hash && !/^#/.test(hash)) {
        hash = '#' + hash;
    }
    !hash && (hash = '');
    search && (search = '?' + search);
    url = page + search + hash;
    return url;
}

function removeHash(url) {
    var page = getPage(url);
    var search = getSearch(url);
    search && (search = '?' + search);
    url = page + search;
    return url;
}

export default {
    getPage: getPage,
    getPageName: getPageName,
    getPath: getPath,
    getSearch: getSearch,
    getHash: getHash,
    writeParam: writeParam,
    setHash: setHash,
    removeHash: removeHash,
    changePage: changePage,
    changePageKeepState: changePageKeepState
};
/* eslint-enable */
